"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSupported = exports.getFirstLedgerDevice = exports.getLedgerDevices = exports.requestLedgerDevice = undefined;

var requestLedgerDevice = exports.requestLedgerDevice = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var device;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return navigator.usb.requestDevice({ filters: ledgerDevices });

          case 2:
            device = _context.sent;
            return _context.abrupt("return", device);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function requestLedgerDevice() {
    return _ref.apply(this, arguments);
  };
}();

var getLedgerDevices = exports.getLedgerDevices = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var devices;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return navigator.usb.getDevices();

          case 2:
            devices = _context2.sent;
            return _context2.abrupt("return", devices.filter(function (d) {
              return d.vendorId === _devices.ledgerUSBVendorId;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getLedgerDevices() {
    return _ref2.apply(this, arguments);
  };
}();

var getFirstLedgerDevice = exports.getFirstLedgerDevice = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var existingDevices;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getLedgerDevices();

          case 2:
            existingDevices = _context3.sent;

            if (!(existingDevices.length > 0)) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", existingDevices[0]);

          case 5:
            return _context3.abrupt("return", requestLedgerDevice());

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getFirstLedgerDevice() {
    return _ref3.apply(this, arguments);
  };
}();

var _devices = require("@ledgerhq/devices");

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var ledgerDevices = [{ vendorId: _devices.ledgerUSBVendorId }];

var isSupported = exports.isSupported = function isSupported() {
  return Promise.resolve(
  // $FlowFixMe
  !!navigator && !!navigator.usb && typeof navigator.usb.getDevices === "function");
};
//# sourceMappingURL=webusb.js.map